<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <h2 class="title mb-3">ライター別月次レポート</h2>
        <permission-guard situation="order_management">
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ライター名</th>
                  <th class="text-left" />
                  <th class="text-left" />
                </tr>
              </thead>
              <tbody>
                <tr v-for="report in writerMonthlyReports" :key="report.id">
                  <td>{{ report.userName }}</td>
                  <td>{{ report.month | formattedMonth }}</td>
                  <td>
                    <v-btn
                      outlined
                      color="primary"
                      small
                      @click="showReportDetail(report)"
                    >
                      確認する
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </permission-guard>
      </v-col>
    </v-row>

    <v-dialog v-model="displayReportDetail" max-width="1000">
      <v-card>
        <v-card-title>
          {{ selectedMonthlyReport.userName }}様 月次レポート
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="5">
              <v-card outlined>
                <v-card-subtitle> 月次 </v-card-subtitle>
                <v-card-text>
                  <div class="text-center display-1">
                    {{ selectedMonthlyReport.month | formattedMonth }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card outlined>
                <v-card-subtitle> 執筆本数 </v-card-subtitle>
                <v-card-text>
                  <div v-if="selectedMonthlyReport.orders" class="text-center">
                    <span class="display-1">
                      {{ selectedMonthlyReport.orders.length }}
                    </span>
                    &nbsp;本
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-5">
              <v-divider />
              <v-simple-table fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>発注id</th>
                      <th style="width: 300px">タイトル</th>
                      <th>規定文字数</th>
                      <th>完了日時</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="order in selectedMonthlyReport.orders"
                      :key="order.id"
                    >
                      <td>{{ order.id }}</td>
                      <td>{{ order.post.title }}</td>
                      <td>{{ order.requiredWords }}</td>
                      <td>{{ order.completedAt | moment }}</td>
                      <td class="text-center">
                        <router-link
                          class="editLink"
                          :to="{
                            name: 'orderedPostEdit',
                            params: { orderId: order.id },
                          }"
                          target="_blank"
                        >
                          <v-btn
                            class="ma-2"
                            tile
                            outlined
                            small
                            color="success"
                          >
                            <v-icon left small> mdi-pencil </v-icon>
                            確認する
                          </v-btn>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import moment from 'moment'
import headUtilsMixin from '@/mixins/head_utils'
import { mapState } from 'vuex'
import PermissionGuard from '@/components/commons/PermissionGuard'

export default {
  components: { PermissionGuard },
  filters: {
    moment: function (val) {
      if (val) {
        return moment(val).format('YYYY年M月D日 HH時mm分')
      }
    },
    formattedMonth (monthNum) {
      if (monthNum) {
        const stringMonth = monthNum.toString()
        const year = stringMonth.slice(0, 4)
        const month = stringMonth.slice(4, 6).replace(/^0/, '')
        return `${year}年 ${month}月`
      }
    }
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      page: 1,
      pageTitle: 'ライター別月次レポート',
      writerMonthlyReports: [],
      displayReportDetail: false,
      selectedMonthlyReport: {}
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.UserStore.currentUser
    })
  },
  mounted: function () {
    axios.get('/api/writer_monthly_reports').then(
      ({ data }) => {
        this.writerMonthlyReports = deserialize(data).data
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    showReportDetail (monthlyReport) {
      this.selectedMonthlyReport = monthlyReport
      this.displayReportDetail = true
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
